<template>
  <div class="home">
    <el-carousel class="carousel" :interval="500000000">
      <el-carousel-item v-for="(item, index) in carouselChart" :key="index">
        <el-image :src="item" fit="cover" />
      </el-carousel-item>
    </el-carousel>
    <div class="bgBox">
      <div class="box1">
        <h1>珠海灏睿科技有限公司</h1>
        <div class="introductionContent">
          <span
            ><p>
              珠海灏睿科技有限公司2019年注册成立，公司自建立来就致力于智慧医疗行业发展，希望改变百姓的就医方式，成为医疗行业的标杆，所自主研发的智慧医疗云平台系统让群众可就近享有优质医疗资源，真正缓解群众“看病难，看病贵”的问题，让百姓少跑冤枉路，少花冤枉钱，帮助百姓最大限度节约就医成本。
            </p>
            <p>
              公司拥有多项自主研发的医疗软件和医疗设备等产品，以及多项核心发明专利。目前公司已授权专利31项，软件著作权26项，商标23项，待申请专利60多项。2023年已通过ISO9001质量体系认证、电信增值业务许可证、科技型中小企业认证、国家级高新技术企业和广东省专精特新企业。其中智慧云门诊系统获得了国家卫健委医药卫生基金管理办公室的医学研究成果一等奖、中国科学家论坛“创新中国·2020科技（技术）创新示范单位”等荣誉称号。
              其中“智慧云门诊系统平台”为全国首创及持续领跑，解决了智慧医疗最后一公里，拥有全国唯一的发明专利。
            </p></span
          >
        </div>
      </div>
      <div class="box2">
        <customTitle
          chinese="公司产品"
          english="COMPANY PRODUCTS"
        ></customTitle>
        <div class="softwareIntroduction">
          <div>
            <h1>灏睿云医</h1>
            <p>
              灏睿云医为医生和患者提供的在线远程门诊平台通过云医生能够实现医生与患者之间随时门诊，同时可以通过远程会诊功能，与其他医生一同讨论病案。通过资源的整合和价值营销引导患者到正确的医院找正确的医生就诊，避免医疗资源的过度浪费。
            </p>
            <div>
              <el-button @click="goSoftwareProduct" round>查看详情</el-button>
            </div>
          </div>
          <div>
            <img src="@/assets/Home/Device.png" />
          </div>
        </div>
        <div class="hardwareProductIntroduction">
          <div>
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in deviceList" :key="index">
                <img :src="item" />
              </swiper-slide>
            </swiper>
          </div>
          <div>
            <h1>智慧医疗云门诊工作站</h1>
            <p>
              通过信息技术与医疗卫生的深度整合，建立覆盖省市县乡村医疗服务机构和个人的市级网络医疗服务平台实现群众足不出户，不出村也能看病，并能享受县级或三甲医院机构的就医水平。
            </p>
            <div>
              <el-button @click="goHardwareProducts" round>查看详情</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="box5">
      <customTitle
        chinese="新闻资讯"
        english="NEWS AND INFORMATION"
      ></customTitle>
      <div class="consultationContent">
        <div class="companyInformation">
          <div>
            <img src="@/assets/Home/news.jpg" />
          </div>
          <div @click="goNewsDetail(companyDynamics.id)">
            <p>
              {{ companyDynamics.newsTitle }}
            </p>
            <span>{{ companyDynamics.newsTags }}</span>
          </div>
        </div>
        <ul class="consultationList">
          <li
            v-for="item in newsList"
            :key="item.id"
            @click="goNewsDetail(item.id)"
          >
            <div>
              {{ item.typeName }}
            </div>
            <div>
              <p>
                {{ item.newsTitle }}
              </p>
              <span>{{ item.newsTags }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="box3">
      <customTitle
        chinese="公司优势"
        english="COMPANY ADVANTAGES"
      ></customTitle>
      <!-- <div class="advantagesContent">
        <div>
          <img src="@/assets/Home/logo1.png" />
          <p>10以上医疗行业<br />从业经验</p>
        </div>
        <div>
          <img src="@/assets/Home/logo2.png" />
          <p>多年专注互联网<br />产品设计</p>
        </div>
        <div>
          <img src="@/assets/Home/logo3.png" />
          <p>擅长医疗软件<br />程序开发</p>
        </div>
        <div>
          <img src="@/assets/Home/logo4.png" />
          <p>众多经验丰富<br />医疗专家</p>
        </div>
      </div> -->
    </div>
    <div class="box4">
      <customTitle chinese="公司专利" english="COMPANY PATENTS"></customTitle>
      <div class="caseContent">
        <img src="@/assets/Home/patents.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import customTitle from "@/components/customTitle";
import { getNewsList } from "@/api/news";
export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide,
    customTitle,
  },
  data() {
    return {
      scrollY: "",
      scrollY2: "",
      scrollY3: "",
      carouselChart: [
        require("@/assets/Home/bg4.png"),
        require("@/assets/Home/bg3.png"),
        require("@/assets/Home/bg5.png"),
      ],
      deviceList: [
        require("@/assets/HardwareProducts/shebei1.png"),
        require("@/assets/HardwareProducts/shebei2.png"),
        require("@/assets/HardwareProducts/deluxeEdition.png"),
        require("@/assets/HardwareProducts/homeEdition.png"),
      ],
      newsList: [],
      companyDynamics: [],
      swiperOption: {
        effect: "coverflow",
        // 设置slider容器能够同时显示的slides数量(carousel模式)
        slidesPerView: 3,
        // 设定为true时，active slide会居中，而不是默认状态下的居左(false)
        centeredSlides: true,
        // 滑动速度
        speed: 1500,
        // 在slide之间设置距离（单位px）
        spaceBetween: 10,
        // 设定初始化时slide的索引，Swiper默认初始化时显示第一个slide
        initialSlide: 0,
        // 循环播放
        loop: true,
        // 自动播放
        autoplay: {
          // 隔×秒自动滑动一次
          delay: 1000,
          // 设置为false，用户操作swiper之后自动切换不会停止，每次都会重新启动autoplay。默认为true
          disableOnInteraction: false,
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.showIcon);
    if (this.isMobile()) {
      this.scrollY = "200";
      this.scrollY2 = "600";
      this.scrollY3 = "1300";
      console.log("移动端");
    } else {
      this.scrollY = null;
      this.scrollY2 = null;
      this.scrollY3 = null;
    }
  },
  created() {
    this.init();
    this.getCompanyDynamics();
  },
  methods: {
    init() {
      let data = {
        pageNum: 1,
        pageSize: 5,
      };
      getNewsList(data).then((res) => {
        this.newsList = res.data.records;
        this.newsList.forEach((item) => {
          let type = item.newsType;
          switch (type) {
            case "0":
              item.typeName = "行业资讯";
              break;
            case "1":
              item.typeName = "热点新闻";
              break;
            case "2":
              item.typeName = "公司动态";
              break;
            case "3":
              item.typeName = "政策法规";
              break;
          }
        });
      });
    },
    //获取公司动态第一条
    getCompanyDynamics() {
      let data = {
        pageNum: 1,
        pageSize: 1,
        newsType: "2",
      };
      getNewsList(data).then((res) => {
        this.companyDynamics = res.data.records[0];
      });
    },
    //监听滚动条
    showIcon() {
      // console.log(document.documentElement.scrollTop);
      if (document.documentElement.scrollTop >= 200) {
        this.scrollY = document.documentElement.scrollTop;
      }
      if (document.documentElement.scrollTop >= 700) {
        this.scrollY2 = document.documentElement.scrollTop;
      }
      if (document.documentElement.scrollTop >= 1300) {
        this.scrollY3 = document.documentElement.scrollTop;
      }
    },
    //判断是否在移动端
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    goSoftwareProduct() {
      this.$router.push("/SoftwareProduct");
    },
    goHardwareProducts() {
      this.$router.push("/HardwareProducts");
    },
    goNewsDetail(id) {
      this.$router.push({ path: "/NewsDetail", query: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>